import { cn } from "@/lib/utils";

type Props = {
  title: string;
  shortCode?: string;
  primaryLabel?: string;
  shortCodeLabel?: string;
};

export function AssistantPlanHero({
  title,
  shortCode,
  primaryLabel = "Name",
  shortCodeLabel = "Short code",
}: Props) {
  if (!title.trim() && !shortCode?.trim()) return null;

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {title.trim() ? (
        <div className="min-w-0">
          <p className="text-[11px] font-medium uppercase tracking-wide text-[var(--lm-muted)] dark:text-slate-400">
            {primaryLabel}
          </p>
          <p className="mt-1 text-base font-semibold leading-snug text-[#101828] dark:text-white">
            {title}
          </p>
        </div>
      ) : null}
      {shortCode?.trim() ? (
        <div className="min-w-0">
          <p className="text-[11px] font-medium uppercase tracking-wide text-[var(--lm-muted)] dark:text-slate-400">
            {shortCodeLabel}
          </p>
          <p
            className={cn(
              "mt-1 font-mono text-base font-semibold tracking-tight text-[#1d4ed8] dark:text-blue-300"
            )}
          >
            {shortCode}
          </p>
        </div>
      ) : null}
    </div>
  );
}
